import {
  getSitePermission,
  getWorkspacePermission,
} from '@packages/domains/authorization/permissions/client-permissions';
import type {WorkspacePermissions} from '@packages/domains/authorization/permissions/catalog';
import {abilityFeature} from '../abilityFeature';

function isWorkspaceResource(
  resource: string
): resource is keyof WorkspacePermissions {
  return resource.startsWith('workspace');
}

export const permission = abilityFeature({
  key: 'permission',
  isValid: function isPermissionValid(state, config) {
    if (!state.PermissionsStore) return true;

    const [action, resource] = config;

    if (isWorkspaceResource(resource)) {
      return getWorkspacePermission(action, resource)(state.PermissionsStore);
    }

    return getSitePermission(action, resource)(state.PermissionsStore);
  },
});
